import { StyleSheet } from 'react-native';
import { BaseColor } from '@config';

export default StyleSheet.create({
    contain: {
        //paddingVertical: 10,
        //paddingHorizontal: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    line: {
        width: 1,
        height: 14,
        backgroundColor: BaseColor.grayColor,
        marginLeft: 10,
    },
    contentModeView: {
        width: 30,
        height: '100%',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    contentFilter: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 10,
    },
    bottomModal: {
        justifyContent: 'flex-end',
        margin: 0,
        padding: 15,
        paddingTop: 50,
    },
    contentFilterBottom: {
        width: '100%',
        borderRadius: 20,
        overflow: 'hidden',
        maxHeight: 600,
    },
    contentSwipeDown: {
        paddingVertical: 15,
        alignItems: 'center',
    },
    lineSwipeDown: {
        width: 35,
        height: 4,
        borderRadius: 5,
        backgroundColor: BaseColor.grayColor,
    },
    contentActionModalBottom: {
        flexDirection: 'row',
        paddingVertical: 10,
        borderBottomWidth: 1,
    },
});
